import { render } from "./Dropdown.vue?vue&type=template&id=5b05510b&scoped=true&ts=true"
import script from "./Dropdown.vue?vue&type=script&lang=ts"
export * from "./Dropdown.vue?vue&type=script&lang=ts"

import "./Dropdown.vue?vue&type=style&index=0&id=5b05510b&scoped=true&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b05510b"]])

export default __exports__